<p-inputSwitch [styleClass]="classesToAdd" [disabled]="disabled" [name]="name" [(ngModel)]="value"
    (ngModelChange)="updateValue($event)">
</p-inputSwitch>